import { deleteApi, getApi, postApi } from "../../common/api";

export const getAllJobs = () => {
    return getApi('/api/postJob');
};
export const addJob = (data: any) => {
    return postApi('/api/postJob/addJob', data);
};
export const deleteJob = (id: any) => {
    return deleteApi("/api/postJob/" + id);
};